export default __webpack_public_path__ + "static/media/downArrow.b7bbe07c.svg";